var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 200,
    height: 200,
    viewBox: "0 0 172 172",
    style: {
      fill: "#1FB141"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1fb141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,5.73333c-44.33006,0 -80.26667,35.93661 -80.26667,80.26667c0,44.33006 35.93661,80.26667 80.26667,80.26667c44.33006,0 80.26667,-35.93661 80.26667,-80.26667c-0.0474,-44.31041 -35.95626,-80.21927 -80.26667,-80.26667zM83.14453,17.25599c18.72672,-0.7779 36.96021,6.11803 50.48534,19.09361c13.52513,12.97559 21.17102,30.90753 21.17012,49.6504c-0.04108,37.98016 -30.81984,68.75892 -68.8,68.8c-37.47238,0.04444 -68.089,-29.90761 -68.86678,-67.37194c-0.77777,-37.46433 28.56937,-68.66126 66.01131,-70.17207zM125.70781,51.67839c-1.36135,0.08519 -2.64773,0.65295 -3.62812,1.6013l-53.27969,53.27969l-18.87969,-18.87969c-1.44097,-1.48376 -3.5694,-2.07638 -5.56983,-1.55081c-2.00043,0.52557 -3.56271,2.08785 -4.08828,4.08828c-0.52557,2.00043 0.06705,4.12886 1.55081,5.56983l22.93333,22.93333c2.23891,2.23843 5.86838,2.23843 8.10729,0l57.33333,-57.33333c1.64585,-1.70121 2.07704,-4.23899 1.08542,-6.38832c-0.99162,-2.14933 -3.20217,-3.46832 -5.56459,-3.32027z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.1ec5d9cec945adb6564122aba388988b.svg";
export { ForwardRef as ReactComponent };